import React from 'react';
import { MousePointerClick, Eye, TrendingUp, Search } from 'lucide-react';

export function GSCSummaryCards({ totals }) {
  const cards = [
    { icon: MousePointerClick, label: 'Clics', value: totals.clicks.toLocaleString('fr-FR'), color: 'text-[#002FA7]', testId: 'gsc-total-clicks' },
    { icon: Eye, label: 'Impressions', value: totals.impressions.toLocaleString('fr-FR'), color: 'text-neutral-900', testId: 'gsc-total-impressions' },
    { icon: TrendingUp, label: 'CTR moyen', value: `${totals.ctr}%`, color: 'text-[#2A9D8F]' },
    { icon: Search, label: 'Position moy.', value: totals.position, color: 'text-neutral-900' },
    { icon: Search, label: 'Mots-cles', value: totals.keywordCount, color: 'text-neutral-900' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
      {cards.map((c) => (
        <div key={c.label} className="bg-white border border-neutral-200 p-5">
          <div className="flex items-center gap-2 text-neutral-500 text-sm mb-2">
            <c.icon className="w-4 h-4" /> {c.label}
          </div>
          <p className={`font-mono text-2xl font-bold ${c.color}`} data-testid={c.testId}>{c.value}</p>
        </div>
      ))}
    </div>
  );
}
